import { schemaQuerySnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '@/schema'

import { type Region } from '../regions/types'

export const dashboardTeamQuery = (regionId: string, eveningId: number) =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['teams', regionId, eveningId],
    factory: collections.teams,
    enabled: !!eveningId,
    query: {
      name: `All teams for region ${regionId} and evening ${eveningId}`,
      where: [
        ['regionId', '==', regionId],
        ['eveningId', '==', eveningId],
        ['status', 'not-in', ['DISSOLVED']],
      ],
    },
  })

export const dashboardRegionTeamQuery = (region?: Region) => {
  const eveningId = region?.currentOperatingDate?.eveningId ?? -1
  return schemaQuerySnapshotQueryOptions({
    queryKey: ['teams', region?._id, eveningId],
    factory: collections.teams,
    enabled: !!region?.currentOperatingDate,
    query: {
      name: `All teams for region ${region?._id} and evening ${eveningId}`,
      where: [
        ['regionId', '==', region?._id ?? ''],
        ['eveningId', '==', eveningId],
        ['status', 'not-in', ['DISSOLVED']],
      ],
    },
  })
}
